<!-- Navbar -->
<nav class="navbar navbar-expand-xl navbar-light bg-light">
    <!-- Container wrapper -->
    <div class="container-fluid">
        <!-- Navbar brand -->
        <a class="navbar-brand navbar-brand-logo outline-none" routerLink="/">
            <div class="logo">
                <img *ngIf="logo" [src]="logo" class="h-100" alt="Ledger Sync">
            </div>
        </a>

        <!-- Kept outside the collapsible menu so they stay visible next to the burger on narrow screens (the
             chat popup anchors to its icon, so a hidden icon means an invisible chat). On xl they sit after the
             links, before the user menu. One instance only: the chat opens itself on help cases. -->
        <div class="d-flex align-items-center gap-3 flex-shrink-0 ms-auto ms-xl-3 me-3 order-xl-2">
            <app-chatbot></app-chatbot>
            <app-report-bug></app-report-bug>
            <language-switcher></language-switcher>
        </div>

        <button
                class="navbar-toggler"
                type="button"
                (click)="toggleWrapper()"
                aria-expanded="false"
                aria-label="Toggle navigation"
        >
            <i class="fa fa-bars"></i>
        </button>

        <!-- Collapsible wrapper -->
        <div
                class="collapse navbar-collapse order-xl-1"
                [collapse]="isCollapsed"
        >
            <!-- Left links -->
            <ul class="navbar-nav mb-2 mb-lg-0">
                <ng-container *ngFor="let link of links">
                    <li class="nav-item" [ngClass]="{'dropdown': !!link.children}" dropdown container="body">
                        <!--                        <ng-container *ngIf="link.title === 'Clients'">-->
                        <!--                            <a-->
                        <!--                                    class="nav-link"-->
                        <!--                                    [routerLinkActiveOptions]="{ exact: true }"-->
                        <!--                                    [routerLink]="link.route"-->
                        <!--                                    routerLinkActive="active"-->

                        <!--                                    appUserGuide-->
                        <!--                                    guideId="ADD_CLIENT"-->
                        <!--                                    guideTitle="ADD_CLIENT_GUIDE_TITLE"-->
                        <!--                                    guideText="ADD_CLIENT_GUIDE_TEXT_1"-->
                        <!--                                    guideButtonCaption="NAVIGATE"-->
                        <!--                                    [guideStep]="1"-->
                        <!--                                    [guideNextHandler]="navigateToClients"-->
                        <!--                            >{{link.title}}</a>-->
                        <!--                        </ng-container>-->
                        <!--                        <ng-container *ngIf="link.title !== 'Clients' && !link.children">-->
                        <!--                            <a class="nav-link position-relative"-->
                        <!--                               [routerLinkActiveOptions]="{ exact: true }"-->
                        <!--                               [routerLink]="link.route"-->
                        <!--                               routerLinkActive="active">-->
                        <!--                                {{link.title}}-->
                        <!--                                <span *ngIf="link.beta"-->
                        <!--                                      class="position-absolute badge rounded-pill bg-primary beta-badge">beta</span>-->
                        <!--                            </a>-->
                        <!--                        </ng-container>-->
                        <!--                        <ng-container *ngIf="!!link.children">-->
                        <!--                            -->
                        <!--                        </ng-container>-->
                        <a
                                dropdownToggle
                                class="nav-link position-relative shadow-none"
                                role="button"
                                routerLinkActive="active"
                                [id]="link.id"
                                [routerLinkActiveOptions]="{ exact: link.route === '/' }"
                                [routerLink]="!link.children && link.route || null"

                                appUserGuide
                                [guideId]="link.guide?.guideId"
                                [guideTitle]="link.guide?.guideTitle"
                                [guideText]="link.guide?.guideText"
                                [guideButtonCaption]="link.guide?.guideButtonCaption"
                                [guideStep]="link.guide?.guideStep"
                                [guideNextHandler]="navigateToClients"
                        >
                                {{link.title}}
                            <span *ngIf="link.id === 'task-center' && taskCenterEventCount() > 0"
                                  class="position-absolute task-center-notification-badge"></span>
                            <span *ngIf="link.beta"
                                  class="position-absolute badge rounded-pill bg-primary beta-badge">beta</span>
                            </a>
                        <ng-container *ngIf="link.children">
                            <ul *dropdownMenu class="dropdown-menu">
                                <ng-container *ngFor="let child of link.children">
                                    <li *ngIf="child.visible !== false">
                                        <a *ngIf="!!child.route" class="dropdown-item" [routerLink]="child.route">
                                            {{child.title}}
                                        </a>
                                        <a *ngIf="!!child.url" class="dropdown-item" [href]="child.url" target="_blank" rel="noopener noreferrer">
                                            {{child.title}}
                                        </a>
                                        <span *ngIf="!child.route && !child.url" class="dropdown-item">{{child.title}}</span>
                                    </li>
                                </ng-container>
                            </ul>
                        </ng-container>
                    </li>
                </ng-container>
            </ul>
            <!-- Narrow screens: the user menu lives in the burger menu. -->
            <!-- Here it sits at the left, so its dropdown opens to the right (see .user-menu-start). -->
            <div class="d-flex d-xl-none align-items-center ms-auto me-3 mw-0 user-menu-start">
                <ng-container *ngTemplateOutlet="userMenu"></ng-container>
            </div>
        </div>

        <!-- xl: the user menu comes last, after the icons. mw-0 down the chain lets the long names ellipsize
             instead of pushing everything off-screen. -->
        <div class="d-none d-xl-flex align-items-center me-3 mw-0 order-xl-3">
            <ng-container *ngTemplateOutlet="userMenu"></ng-container>
        </div>
    </div>
    <!-- Container wrapper -->

    <ng-template #userMenu>
        <div dropdown class="nav-item dropdown mw-0">
            <div class="d-flex gap-3 mw-0">
                <div class="align-items-center gap-1 d-none d-md-flex mw-0">
                    <i class="fa fa-building"></i>
                    <div title="{{currentUser.companyName}}"
                         class="text-ellipsis mw-200px">{{currentUser.companyName}}</div>
                </div>
                <div
                        class="nav-link dropdown-toggle d-flex align-items-center user-menu-toggle mw-0"
                        id="userLink"
                        role="button"
                        dropdownToggle
                        aria-expanded="false"
                >
                    <i class="fa fa-user me-1"></i>
                    <div title="{{currentUser.fullName}}"
                         class="text-ellipsis mw-200px">{{currentUser.fullName}}</div>
                </div>
            </div>
            <ul
                    *dropdownMenu
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="userLink"
            >
                <li>
                    <a class="dropdown-item" href="https://ledgersync.com/book-a-demo" target="_blank">
                        <i class="me-2 fa-solid fa-note-sticky"></i> Book 1x1 Support
                    </a>
                </li>
                <li>
                    <hr class="dropdown-divider"/>
                </li>
                <li *ngIf="currentUser.role === CUSTOMER">
                    <a class="dropdown-item" routerLink="/billing-tiered">
                        <i class="me-2 fa-solid fa-money-bill-1"></i>{{'Billing'|translate}}
                    </a>
                </li>

                <li>
                    <a class="dropdown-item" routerLink="/settings">
                        <i class="me-2 fa-solid fa-gears"></i>{{'Settings'|translate}}
                    </a>
                </li>

                <li *ngIf="currentUserIsCustomer || currentUserIsEmployee">
                    <a class="dropdown-item" (click)="downloadFdeApp();">
                        <i class="me-2 fa-solid fa-gears"></i>{{'LS Desktop App'|translate}}
                    </a>
                </li>

<!--                        <li *ngIf="currentUser.role !== 'CLIENT'">-->
<!--                            <a class="dropdown-item" target="_blank"-->
<!--                               href="https://ledgersyncappv2.com/services/api/quickbooks-desktop/installer/download">-->
<!--                                <i class="me-2 fa-solid fa-gears"></i>{{'Quickbooks Desktop Integration'|translate}}-->
<!--                            </a>-->
<!--                        </li>-->

                <li *ngIf="currentUserIsCustomerButNotFirm || currentUserIsCustomer || firmsAvailable">
                    <hr class="dropdown-divider"/>
                </li>

                <li *ngIf="firmsAvailable">
                    <a class="dropdown-item" routerLink="/firms">
                        <i class="me-2 fa fa-plane"></i>{{'Firms'|translate}}
                    </a>
                </li>

                <li *ngIf="employeesAvailable">
                    <a class="dropdown-item" routerLink="/employees">
                        <i class="me-2 fa fa-users"></i>{{'Employees'|translate}}
                    </a>
                </li>

                <li *ngIf="currentUserIsCustomerButNotFirm">
                    <a class="dropdown-item" routerLink="/customer-admin">
                        <i class="me-2 fa-regular fa-life-ring"></i>{{'Customer Admin'|translate}}
                    </a>
                </li>

                <li *ngIf="currentUserIsCustomerButNotFirm">
                    <a class="dropdown-item" routerLink="/permissions">
                        <i class="me-2 fa fa-lock w-16 text-center"></i>Permissions
                    </a>
                </li>

<!--                        <li>-->
<!--                            <hr class="dropdown-divider"/>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <span class="dropdown-item" (click)="showPdfConverter()">-->
<!--                                <i class="me-2 fa  fa-file-pdf"></i>{{'OCR Account Analysis Statement'|translate}}-->
<!--                            </span>-->
<!--                        </li>-->
                <li>
                    <hr class="dropdown-divider"/>
                </li>
                <li>
                    <a class="dropdown-item" href="https://ledgersync.com/legal/terms" target="_blank">
                        <i class="me-2 fa fa-gavel"></i>{{'Terms & Conditions'|translate}}
                    </a>
                </li>
                <li>
                    <a class="dropdown-item" href="mailto:support@ledgersync.com">
                        <i class="me-2 fa fa-envelope"></i>{{'Contact us'|translate}}
                    </a>
                </li>
                <li>
                    <a class="dropdown-item" routerLink="/support/help-center" target="_blank">
                        <i class="me-2 fa fa-ticket"></i>{{'My support tickets'|translate}}
                    </a>
                </li>
<!--                        <li>-->
<!--                            <a class="dropdown-item" [href]="banksListUrl">-->
<!--                                <i class="me-2 fa-solid fa-building-columns"></i>{{'Supported Banks'|translate}}-->
<!--                            </a>-->
<!--                        </li>-->
                <li>
                        <span class="dropdown-item cursor-pointer" (click)="requestNewBank()">
                            <i class="me-2 fa-solid fa-building-columns"></i>{{'Request New Bank'|translate}}
                        </span>
                </li>
                <li>
                        <a class="dropdown-item cursor-pointer" href="https://developer.mastercard.com/open-banking-us/documentation/financial-institution/supported-institutions/"
                           target="_blank">
                            <i class="me-2 fa-solid fa-building-columns"></i>{{'Mastercard Supported Banks'|translate}}
                        </a>
                </li>
                <li>
                    <hr class="dropdown-divider"/>
                </li>
                <li *ngIf="currentUser.isCompanyOwner">
                    <a class="dropdown-item" routerLink="/settings/customization">Customize</a>
                </li>
                <li class="cursor-pointer" (click)="logout()">
                    <span class="dropdown-item">Logout</span>
                </li>
            </ul>
        </div>
    </ng-template>
</nav>
<!-- Navbar -->
